type ValueType = string | boolean | null | number | undefined

// Walk over a list of provided values and find the first non-empty value
// (numeric and boolean 'false'-alike values are allowed to be returned)
// Defaults to the last value
// The value is converted to string by default, because we use strings in most cases for SEO
function getFirstNotEmpty(data: Array<ValueType>, asString?: true): string
function getFirstNotEmpty(data: Array<ValueType>, asString: false): ValueType
function getFirstNotEmpty(data: Array<ValueType>, asString = true): ValueType {
    const value = data.find(
        (entry: unknown, idx) =>
            (typeof entry !== 'undefined' && entry !== null && entry !== '') ||
            idx === data.length - 1
    )
    return asString ? String(value) : value
}

export default getFirstNotEmpty
